import SupportElement from "../../classes/support/SupportElement";

export default class NoneSupportElement extends SupportElement {
  constructor(id, name, supportReaction) {
    super(id, name, supportReaction);
    this.classType="NoneSupportElement";
  }
}
